import { useClassName } from '@/styles/ArticleHeader';
import { PropsFromComponent, PropsFromSubcomponents } from '@/types/component';
import { GenericComponentFactory } from 'base/components/GenericComponent';

export type ArticleHeaderProps = PropsFromComponent<typeof ArticleHeader>;
export type ArticleHeaderSubcomponentProps = PropsFromSubcomponents<typeof ArticleHeader>;

const GenericComponent = GenericComponentFactory({ useClassName }); 

const options = { defaults: { variant: 'first' } };

const Base = GenericComponent({ as: 'header', styles: { key: '' }, options });
const Bylines = GenericComponent({ as: 'div', styles: { key: 'bylines' }, options });
const Category = GenericComponent({ as: 'div', styles: { key: 'category' }, options });
const Date = GenericComponent({ as: 'div', styles: { key: 'date' }, options });
const Description = GenericComponent({ as: 'div', styles: { key: 'description' }, options });
const Headline = GenericComponent({ as: 'h1', styles: { key: 'headline' }, options });
const Image = GenericComponent({ as: 'div', styles: { key: 'image' }, options });
const Tags = GenericComponent({ as: 'div', styles: { key: 'tags' }, options });

export const ArticleHeader = Object.assign(Base, {
  Bylines,
  Date,
  Category,
  Description,
  Headline,
  Image,
  Tags,
});
